<template>
  <div id="app">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0;display: flex " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">我的信息</span>
      </p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">删除</p>-->
    </header>
    <div class="inforTop">
      <div class="headerP">
        <div >头像</div>
        <!--<div style="color: #FFA500">上传真实头像,你的简历更加分</div>-->
      </div>
      <div class="inforImg">
        <img style="" src="@/assets/img/tx.jpg" alt="">
      </div>
    </div>
    <div class="inforSix">
      <!--<van-field label="文本" value="输入框只读" readonly />-->
      <!--<van-field label="文本" value="输入框已禁用" disabled />-->
      <van-cell-group>
        <van-field label="姓名"  readonly />
        <van-field  v-model="data.nickName" />
      </van-cell-group>
      <!--<p>姓名</p>-->
      <!--<p></p>-->
    </div>



    <div class="inforName">
    <van-cell-group>
      <van-field label="接受简历邮箱"  readonly />
      <van-field  v-model="data.email" />
    </van-cell-group>
  </div>
    <div class="inforName">
      <!--<p>所在城市</p>-->
      <!--<p>北京</p>-->
      <van-cell-group>
        <van-field label="职位"  readonly />
        <van-field   v-model="data.positions" />
      </van-cell-group>
    </div>
    <div class="inforName">
      <van-cell-group>
        <van-field label="我的公司"  readonly />
        <van-field   v-model="data.company_name" />
      </van-cell-group>
    </div>

    <div class="button">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="sveLeaderPositioner()">保存</van-button>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
//        transitionName: 'slideleft'
        radio:"",
        data:{
          nickName:'',
          email:'',
          positions:'',
          company_name:'',
        },
        name:"1",
        list:'',
        id:''
      }
    },
    mounted(){
      this.getComMyer()
//      this.sveLeaderPositioner()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      getComMyer(){
        this.$api.getComMy({'id':localStorage.getItem("userid")})
          .then(res=>{
            if(res.status==200){
              this.data= res.data
//              this.id=res.data[0].id
//              this.data.sex=this.data.sex?`${this.data.sex}`:"";
            }
          })
          .catch(res=>{

          })
      },
      sveLeaderPositioner(){
        this.$api.sveLeaderPosition({
          'id':localStorage.getItem("userid"),
          "data[nickName]": this.data.name,
          "data[email]":  this.data.email,
          "data[positions]":this.data.position,
//          "data[company_name]": this.data.company_name,
        })
          .then(res=>{
            if(res.status){
              this.$router.push("/comMy")
            }
          })
          .catch(res=>{

          })
      }
    }
  }
</script>

<style scoped="">
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .inforTop{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    margin-top: 100px;
  }
  .inforImg{
    width: 60px;
    height: 60px;
  }
  .inforImg img{
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
  .inforName{
    width: 90%;
    margin: auto;
    border-bottom: solid 1px #DEDEDE;
  }
  /*.inforName :first-child{*/
  /*color: #DEDEDE;*/
  /*}*/
  .van-cell::after{
    border: 0;
  }
  .inforSix{
    display: flex;
    width: 90%;
    margin: auto;
    border-bottom: solid 1px #DEDEDE;
  }
  .van-cell-group{
    width: 60%;
  }
  .van-cell{
    padding: 10px 0px;
  }
  .button{
    position: fixed;
    width: 100%;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/comMyinfor.vue